export default {
    type: 'panel',
    name: 'prefooter',
    blocks: [
        {
            name: 'image',
            type: 'image',
			max: 1,
        },
        {
            name: 'title',
            max: 1,
            type: 'text',
        },
        {
            name: 'content', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'html', // || text || link || image || mixed (with children)
        },
    ],
};
